module.exports = __webpack_public_path__ + "img/organ-solutions.76a1b04.svg";